import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs-compat';
import { VestibularService } from '../shared/vestibular.service';
import { BlockingSpinnerService } from 'app/core/blocking-spinner/blocking-spinner.service';

@Component({
  selector: 'cm-redirecionamento',
  templateUrl: './redirecionamento.component.html',
  styleUrls: ['./redirecionamento.component.scss']
})
export class RedirecionamentoComponent implements OnInit {

  queryParamsSubscription: Subscription;
  public vestibularInfo;

  constructor(private router: Router, private activeRouter: ActivatedRoute, private vestibularService: VestibularService, private spinner: BlockingSpinnerService) {
   }

  ngOnInit() {
    this.spinner.show();
    this.queryParamsSubscription = this.activeRouter.params.subscribe((param)=>{
      let dataEnviar = {
        data: param['data']
      }
      this.vestibularService.pegaDadosMarketPlace(dataEnviar).subscribe((result)=>{
        sessionStorage.setItem("marketPlaceData", JSON.stringify(result));
        this.spinner.close();
        this.router.navigate([`vestibular/inscricao/${result['anoVestibular']}/${result['codigoVestibular']}/curso`]);
      }, (error) =>{
        this.spinner.close();
        this.router.navigate([""]);
      });
    })
  }




}
